import Vue from "vue";
import VueRouter from "vue-router";

import NProgress from "nprogress";

import "nprogress/nprogress.css";

Vue.use(VueRouter);

let router = new VueRouter({
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("../views/Home.vue")
        },
        {
            path: "/blank",
            name: "blank",
            component: () => import("../views/Blank.vue")
        },
    ]
});

// router.beforeEach((to, from, next) => {
//     NProgress.start()
//     next()
// })

// router.afterEach(() => {
//     NProgress.done()
// })

export default router = router;
